/**
 * Alpha42 theme interactions
 */
(function () {
  'use strict';

  function initMobileNav() {
    const toggle = document.querySelector('[data-a42-menu-toggle]');
    const drawer = document.querySelector('[data-a42-mobile-drawer]');
    if (!toggle || !drawer) return;

    const closeEls = drawer.querySelectorAll('[data-a42-menu-close]');

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('a42-menu-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(!drawer.classList.contains('is-open'));
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  function initAssessment() {
    const root = document.querySelector('[data-a42-assessment]');
    if (!root) return;

    const questions = JSON.parse(root.dataset.questions || '[]');
    const outcomes = JSON.parse(root.dataset.outcomes || '{}');
    const maxScore = parseInt(root.dataset.maxScore || '36', 10);
    const storageKey = 'a42_assessment_score';

    let step = 0;
    let score = 0;
    const answers = [];

    const progressBar = root.querySelector('[data-a42-progress]');
    const categoryEl = root.querySelector('[data-a42-category]');
    const questionEl = root.querySelector('[data-a42-question]');
    const optionsEl = root.querySelector('[data-a42-options]');
    const resultEl = root.querySelector('[data-a42-result]');
    const gateEl = root.querySelector('[data-a42-gate]');
    const nextBtn = root.querySelector('[data-a42-next]');
    const prevBtn = root.querySelector('[data-a42-prev]');
    const quizEl = root.querySelector('[data-a42-quiz]');

    const postedSuccess =
      !!root.querySelector('[data-a42-posted-success]') ||
      new URLSearchParams(window.location.search).has('customer_posted');

    function getTier(total) {
      if (total <= 12) return 'vulnerable';
      if (total <= 24) return 'developing';
      return 'prepared';
    }

    function renderQuestion() {
      if (step >= questions.length) {
        showGate();
        return;
      }

      const q = questions[step];
      if (categoryEl) categoryEl.textContent = q.category || '';
      questionEl.textContent = q.text;
      optionsEl.innerHTML = q.options
        .map(function (opt) {
          return (
            '<label><input type="radio" name="q' +
            step +
            '" value="' +
            opt.value +
            '"><span>' +
            opt.label +
            '</span></label>'
          );
        })
        .join('');

      const saved = answers[step];
      if (saved !== undefined) {
        const input = optionsEl.querySelector('input[value="' + saved + '"]');
        if (input) input.checked = true;
      }

      if (progressBar) {
        progressBar.style.width = ((step / questions.length) * 100).toFixed(0) + '%';
      }
      prevBtn.hidden = step === 0;
      nextBtn.textContent = step === questions.length - 1 ? 'See results' : 'Next';
    }

    function showGate() {
      quizEl.hidden = true;
      gateEl.hidden = false;
      try {
        localStorage.setItem(storageKey, String(score));
      } catch (e) {
        /* ignore storage errors */
      }
      const hiddenTier = gateEl.querySelector('[data-a42-tier-input]');
      if (hiddenTier) hiddenTier.value = getTier(score) + ' (' + score + '/' + maxScore + ')';
      if (progressBar) progressBar.style.width = '100%';
    }

    function showResult(finalScore) {
      quizEl.hidden = true;
      gateEl.hidden = true;
      resultEl.hidden = false;

      const tier = getTier(finalScore);
      const outcome = outcomes[tier] || { title: tier, description: '' };
      const scoreEl = resultEl.querySelector('[data-a42-score]');
      const maxEl = resultEl.querySelector('[data-a42-max]');

      if (scoreEl) scoreEl.textContent = String(finalScore);
      if (maxEl) maxEl.textContent = String(maxScore);
      resultEl.querySelector('[data-a42-tier]').textContent = outcome.title;
      resultEl.querySelector('[data-a42-tier-desc]').textContent = outcome.description;
      if (progressBar) progressBar.style.width = '100%';

      try {
        localStorage.removeItem(storageKey);
      } catch (e) {
        /* ignore storage errors */
      }
    }

    nextBtn.addEventListener('click', function () {
      const selected = optionsEl.querySelector('input:checked');
      if (!selected) return;
      const value = parseInt(selected.value, 10);
      if (answers[step] !== undefined) {
        score -= answers[step];
      }
      answers[step] = value;
      score += value;
      step += 1;
      renderQuestion();
    });

    prevBtn.addEventListener('click', function () {
      if (step > 0) {
        step -= 1;
        renderQuestion();
      }
    });

    if (postedSuccess) {
      let storedScore;
      try {
        storedScore = localStorage.getItem(storageKey);
      } catch (e) {
        storedScore = null;
      }
      if (storedScore !== null && storedScore !== '') {
        showResult(parseInt(storedScore, 10));
        return;
      }
    }

    const hasFormErrors = !!gateEl.querySelector('.a42-assessment__errors');
    if (hasFormErrors) {
      quizEl.hidden = true;
      gateEl.hidden = false;
      let storedScore;
      try {
        storedScore = localStorage.getItem(storageKey);
      } catch (e) {
        storedScore = null;
      }
      if (storedScore !== null && storedScore !== '') {
        score = parseInt(storedScore, 10);
        const hiddenTier = gateEl.querySelector('[data-a42-tier-input]');
        if (hiddenTier) hiddenTier.value = getTier(score) + ' (' + score + '/' + maxScore + ')';
      }
      if (progressBar) progressBar.style.width = '100%';
      return;
    }

    renderQuestion();
  }

  function initProductTabs() {
    document.querySelectorAll('[data-a42-product-tabs]').forEach(function (tabs) {
      const buttons = tabs.querySelectorAll('[data-a42-tab]');
      const panels = tabs.querySelectorAll('[data-a42-panel]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const id = btn.dataset.a42Tab;
          buttons.forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          panels.forEach(function (p) {
            p.hidden = p.dataset.a42Panel !== id;
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initAssessment();
    initProductTabs();
  });
})();
